import { SMARTLY_UPLOADS_DOMAIN, QUANTIC_UPLOADS_DOMAIN } from 'PedagoDomainConstants';
import { angularInjectorProvider } from 'Injector';
import { type LinkTarget } from './Navigation.types';

function modifyTargetForCordova(url: string, origTarget: LinkTarget): LinkTarget {
    const $injector = angularInjectorProvider.requireInjector();
    const $window = $injector.get('$window');

    if (!$window.CORDOVA) return origTarget;

    if (origTarget === '_blank') {
        return '_system';
    }

    // external links should open the system browser on mobile
    if (isExternalHref(url) && origTarget === '_self') {
        return '_system';
    }

    return origTarget;
}

export function modifyTarget(url: string | undefined | null, origTarget?: LinkTarget | null): LinkTarget {
    let target = origTarget || '_self';
    if (!url) return target;

    if (isExternalHref(url) && !origTarget) target = '_blank';

    return modifyTargetForCordova(url, target);
}

export function modifyHref(href: string | null | undefined): string {
    if (!href) return '';
    return href.replace(`//${SMARTLY_UPLOADS_DOMAIN}`, `//${QUANTIC_UPLOADS_DOMAIN}`);
}

export function isExternalHref(href: string) {
    return /^https?:\/\//.test(href);
}
